import * as React from 'react';
import type { RouteConfig } from 'types';
import Entry from './Entry';
import { hasBootGuidePermission } from './permission';

const Index = React.lazy(() => import('./pages/Index'));
const Basic = React.lazy(() => import('./pages/Basic'));
const AiModel = React.lazy(() => import('./pages/AiModel'));
const Advanced = React.lazy(() => import('./pages/Advanced'));
const Reuse = React.lazy(() => import('./pages/Reuse'));
const BasicEnd = React.lazy(() => import('./pages/BasicEnd'));
const AiModelEnd = React.lazy(() => import('./pages/AiModelEnd'));
const AdvancedEnd = React.lazy(() => import('./pages/AdvancedEnd'));
const ReuseEnd = React.lazy(() => import('./pages/ReuseEnd'));
const Marketing = React.lazy(() => import('./pages/Marketing'));
const AiSaleBot = React.lazy(() => import('./pages/AiSaleBot'));
const AiAssistantBot = React.lazy(() => import('./pages/AiAssistantBot'));
const AiSaleBotAdvanced = React.lazy(() => import('./pages/AiSaleBotAdvanced'));
const MarketingEnd = React.lazy(() => import('./pages/MarketingEnd'));
const AiSaleBotEnd = React.lazy(() => import('./pages/AiSaleBotEnd'));
const AiAssistantBotEnd = React.lazy(() => import('./pages/AiAssistantBotEnd'));
const AiSaleBotAdvancedEnd = React.lazy(() => import('./pages/AiSaleBotAdvancedEnd'));

const BootGuideRouter: RouteConfig = {
  path: 'bootguide',
  redirect: '/bootguide/index',
  element: <Entry />,
  i18nHelmetTitle: 'guide_label',
  access: (props) => {
    return hasBootGuidePermission(props) ? 'write' : false;
  },
  children: [
    {
      path: 'index',
      element: <Index />,
    },
    {
      path: 'basic/end',
      element: <BasicEnd />,
    },
    {
      path: 'basic/:stepName',
      element: <Basic />,
    },
    {
      path: 'ai_model/end',
      element: <AiModelEnd />,
    },
    {
      path: 'ai_model/:stepName',
      element: <AiModel />,
    },
    {
      path: 'advanced/end',
      element: <AdvancedEnd />,
    },
    {
      path: 'advanced/:stepName',
      element: <Advanced />,
    },
    {
      path: 'reuse/end',
      element: <ReuseEnd />,
    },
    {
      path: 'reuse/:configType',
      element: <Reuse />,
    },
    {
      path: 'marketing/end',
      element: <MarketingEnd />,
    },
    {
      path: 'aiSaleBot/end',
      element: <AiSaleBotEnd />,
    },
    {
      path: 'aiAssistantBot/end',
      element: <AiAssistantBotEnd />,
    },
    {
      path: 'aiSaleBotAdvanced/end',
      element: <AiSaleBotAdvancedEnd />,
    },
    {
      path: 'marketing/:stepName',
      element: <Marketing />,
    },
    {
      path: 'aiSaleBot/:stepName',
      element: <AiSaleBot />,
    },
    {
      path: 'aiAssistantBot/:stepName',
      element: <AiAssistantBot />,
    },
    {
      path: 'aiSaleBotAdvanced/:stepName',
      element: <AiSaleBotAdvanced />,
    },
  ],
};

export default BootGuideRouter;
